import { gql } from "@apollo/client";

export const OWNED_PHONE_NUMBER_FIELDS = gql`
  fragment OwnedPhoneNumberFields on OwnedPhoneNumber {
    id
    phoneNumber
    displayName
    provider
    messageClass
    shortCodeType
    tenDlcCampaignId
    state
    provisioningState
    ownedPhoneNumberPool {
      id
      name
      type
      createdAt
      tenantId
    }
    shortCodeConfig {
      helpKeywords
      helpMessage
      optInKeywords
      optInMessage
      optOutKeywords
      optOutMessage
    }
    createdAt
    subaccounts {
      subaccountId
      state
      isPrimary
    }
    optInGroup {
      id
      name
      ownedPhoneNumbers {
        id
        subaccounts {
          subaccountId
          state
        }
      }
    }
  }
`;

export const LIST_OWNED_PHONE_NUMBERS = gql`
  ${OWNED_PHONE_NUMBER_FIELDS}
  query ListOwnedPhoneNumbers($input: ListOwnedPhoneNumbersInput!) {
    listOwnedPhoneNumbers(input: $input) {
      ...OwnedPhoneNumberFields
    }
  }
`;

export const LIST_ACTIVE_OWNED_PHONE_NUMBERS = gql`
  ${OWNED_PHONE_NUMBER_FIELDS}
  query ListActiveOwnedPhoneNumbers($input: ListActiveOwnedPhoneNumbersInput!) {
    listActiveOwnedPhoneNumbers(input: $input) {
      ...OwnedPhoneNumberFields
    }
  }
`;

export const IMPORT_OWNED_PHONE_NUMBER = gql`
  ${OWNED_PHONE_NUMBER_FIELDS}
  mutation ImportOwnedPhoneNumber($input: ImportOwnedPhoneNumberInput!) {
    importOwnedPhoneNumber(input: $input) {
      ...OwnedPhoneNumberFields
    }
  }
`;

export const EDIT_OWNED_PHONE_NUMBER = gql`
  ${OWNED_PHONE_NUMBER_FIELDS}
  mutation EditOwnedPhoneNumber($input: EditOwnedPhoneNumberInput!) {
    editOwnedPhoneNumber(input: $input) {
      ...OwnedPhoneNumberFields
    }
  }
`;

export const ARCHIVE_OWNED_PHONE_NUMBER = gql`
  ${OWNED_PHONE_NUMBER_FIELDS}
  mutation ArchiveOwnedPhoneNumber($input: ArchiveOwnedPhoneNumberInput!) {
    archiveOwnedPhoneNumber(input: $input) {
      ...OwnedPhoneNumberFields
    }
  }
`;

export const ARCHIVE_OWNED_PHONE_NUMBER_FOR_STAFF = gql`
  ${OWNED_PHONE_NUMBER_FIELDS}
  mutation ArchiveOwnedPhoneNumberForStaff(
    $input: ArchiveOwnedPhoneNumberForStaffInput!
  ) {
    archiveOwnedPhoneNumberForStaff(input: $input) {
      ...OwnedPhoneNumberFields
    }
  }
`;

export const UNARCHIVE_OWNED_PHONE_NUMBER = gql`
  ${OWNED_PHONE_NUMBER_FIELDS}
  mutation UnarchiveOwnedPhoneNumber($input: UnarchiveOwnedPhoneNumberInput!) {
    unarchiveOwnedPhoneNumber(input: $input) {
      ...OwnedPhoneNumberFields
    }
  }
`;

export const REFRESH_OWNED_PHONE_NUMBER_STATUS = gql`
  ${OWNED_PHONE_NUMBER_FIELDS}
  mutation RefreshPhoneNumberStatus($input: RefreshPhoneNumberStatusInput!) {
    refreshPhoneNumberStatus(input: $input) {
      ...OwnedPhoneNumberFields
    }
  }
`;
